import { createFileRoute } from "@tanstack/react-router";
import TicaHoy from "@/pages/TicaHoy";
import { loadResultsSummary } from "@/lib/results-seo";

export const Route = createFileRoute("/tiempos-tica-hoy")({
  loader: ({ context }) => loadResultsSummary(context.queryClient, 0),
  head: ({ loaderData }) => {
    const s = loaderData ?? { dateLabel: "", tica: "", nica: "" };
    const title = `Tiempos Tica Hoy ${s.dateLabel}${s.tica ? `: ${s.tica}` : ""} | Tiempos JPS Costa Rica`;
    const description = `¿Qué salió en Tiempos Tica Hoy? Resultados de Nuevos Tiempos (JPS) de Costa Rica ${s.dateLabel}: ${s.tica || "sorteos de 1pm, 4:30pm y 7:30pm"}. Con Bolita Blanca o Reventado.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://tiemposhoy.com/tiempos-tica-hoy" },
        { name: "twitter:card", content: "summary" },
      ],
      links: [{ rel: "canonical", href: "https://tiemposhoy.com/tiempos-tica-hoy" }],
    };
  },
  component: TicaHoy,
});
